const CONFIRM_MODAL = "#confirmation-modal";
let current = null;
let listening = false;

export function openOverlay({ element, anchor = null, ignore = [], root = null, sheet = false, onClose = null }) {
  closeOverlay({ restoreFocus: false });
  current = { element, anchor, ignore: [anchor, ...ignore].filter(Boolean), root, sheet, onClose };
  if (sheet && root) root.classList.add("tg-sheet-open");
  listen();
  return current;
}

export function closeOverlay({ restoreFocus = true } = {}) {
  if (!current) return false;
  const entry = current;
  current = null;
  if (entry.root) entry.root.classList.remove("tg-sheet-open");
  if (entry.onClose) entry.onClose();
  const anchor = entry.anchor;
  if (restoreFocus && anchor && anchor.isConnected !== false && anchor.focus) anchor.focus({ preventScroll: true });
  return true;
}

export function isOpen(element) {
  return !!current && current.element === element;
}

export function isOpenFrom(element, trigger) {
  return isOpen(element) && current.anchor === trigger;
}

export function handleKeydown(event) {
  if (event.key !== "Escape" || !current) return false;
  if (event.target && event.target.closest && event.target.closest(CONFIRM_MODAL)) return false;
  closeOverlay();
  return true;
}

export function handleClick(event) {
  if (!current) return false;
  const target = event.target;
  if (current.element.contains(target)) return false;
  if (target && target.closest && target.closest(CONFIRM_MODAL)) return false;
  if (current.ignore.some((node) => node.contains && node.contains(target))) return false;
  closeOverlay({ restoreFocus: false });
  return true;
}

function setShown(element, openClass, shown) {
  if (openClass) {
    element.classList.toggle(openClass, shown);
  } else {
    element.hidden = !shown;
  }
}

export function openDisclosure({ element, trigger, root = null, sheet = false, openClass = null, triggerClass = null, onClose = null }) {
  closeOverlay({ restoreFocus: false });
  setShown(element, openClass, true);
  trigger.setAttribute("aria-expanded", "true");
  if (triggerClass) trigger.classList.add(triggerClass);
  return openOverlay({
    element,
    anchor: trigger,
    root,
    sheet,
    onClose: () => {
      setShown(element, openClass, false);
      trigger.setAttribute("aria-expanded", "false");
      if (triggerClass) trigger.classList.remove(triggerClass);
      if (onClose) onClose();
    },
  });
}

export function toggleDisclosure(options) {
  if (isOpen(options.element)) {
    closeOverlay();
    return false;
  }
  openDisclosure(options);
  return true;
}

function listen() {
  if (listening || typeof document === "undefined") return;
  listening = true;
  document.addEventListener("keydown", handleKeydown);
  document.addEventListener("click", handleClick);
}
